import {
    ActionComponentDefinition,
    ComponentWithOptions,
    InputComponent,
    LabeledComponentDefinition,
    ValueComponentDefinition,
} from "components/components/Component";
import { InputBaseComponent } from "components/components/InputBaseComponent";
import { LabelElement } from "components/components/label/labelElement";
import { ComponentActionHelper } from "components/events/componentActionHelper";
import { fireDataChangedEvent } from "components/form/dataChangedEventDetail";
import { OptionHolder, SearcherParameter } from "components/input/select/options";
import { Renderer } from "components/Renderer";
import { TableRestrictions } from "components/restrictions/Restrictions";
import { Table, TableDefinition, TableRestrictionApplicable } from "components/table/table";
import { TableUpdateData } from "components/table/tableUpdateData";
import $ from "jquery";
import { ItemFinderModalDefinition, ParameterMapping } from "components/input/searcherWithCode/baseItemFinderElement";
import { SearcherWithComposedCode } from "components/input/searcherWithCode/searcherWithComposedCode/searcherWithComposedCode";
import { ItemFinderActionDefinition } from "components/input/searcherWithCode/searcherWithSingleCode/itemFinderModalAction";
import { mergeOptions } from "components/input/searcherWithCode/OptionsMergeUtil";
import template from "./referenceTable.hbs";

export class ReferenceTable
    extends InputBaseComponent<ReferenceTableDefinition>
    implements InputComponent, ComponentWithOptions,
    TableRestrictionApplicable {
    public componentType = "referenceTable";
    private code: any = {};
    private table: Table;
    private queryParameters: SearcherParameter[] = [];
    private valid: boolean = true;
    private validationMessage: string = null;

    constructor(schema: ReferenceTableDefinition) {
        super(schema);
        if (schema.labelKey == null || schema.labelKey.length === 0) {
            this.definition.labelWidth = 0;
        }
        this.definition.labelWidth = this.definition.labelWidth ?? 16;
        if (this.definition.table == null) {
            console.error("Missing definition for table in component " + this.definition.property);
            return;
        }
        let params = {
            data: {
                filter: this.queryParameters,
            },
        };

        this.definition.table.actions = [
            {
                id: this.definition.id + "-add-action",
                iconFont: "fa-plus",
                labelKey: "actions.add",
                componentType: "actionButton",
                style: "default",
                action: {
                    actionType: "finder",
                    actionName: "tableReference-add-action",
                    outputParameterMappings: this.definition.outputParameterMappings,
                    finder: this.definition.finder,
                    queryParameters: params,
                } as ItemFinderActionDefinition,
            },
        ];
    }

    public render(): Element {
        let jqueryView = $(template(Object.assign(
            this.definition,
        )));
        this.view = jqueryView[0];
        if (this.definition.table != null) {
            this.table = Renderer.instance().build(this.definition.table) as Table;
            let rendered = Renderer.instance().render((this.table));

            this.view.querySelector(".c-reference-table__table-holder").appendChild(rendered);
        }
        ComponentActionHelper.register(this);
        return this.view;
    }

    public getValue(): TableUpdateData {
        return this.table?.getValue();
    }

    public value(v: any) {
        this.table?.value(v);
    }
    public postRender(): Node {
        this.table?.postRender();
        this.table.view.addEventListener("dataChanged", (evt: CustomEvent) => {
            evt.stopPropagation();
            fireDataChangedEvent(this, this.view, evt.detail.data, evt.detail.originalData, evt.detail.isValid);
        });
        return this.view;
    }

    public setReadOnly(ro: boolean) {
        let addbutton = this.view.querySelector("s6-action-button");
        (addbutton as HTMLButtonElement).disabled = ro;
        this.table.setReadOnly(ro);
    }

    public setRequired(required: boolean) {
        let inputLabel = this.view.querySelector("s6-input-label");
        if (inputLabel != null) {
            (inputLabel as LabelElement).required = required;
        }
    }

    public setValidationStatus(valid: boolean, message?: string | string[] | any) {
        this.valid = valid;
        this.validationMessage = message || null;
    }

    public addOptions(options: OptionHolder): void {
        SearcherWithComposedCode.cleanupOptions(options);
        mergeOptions(this.queryParameters, options);
    }

    public setOptions = this.addOptions;

    public applyRestrictions(restrictions: TableRestrictions): void {
        super.applyRestrictions(restrictions);
        this.table.applyRestrictions(restrictions);
    }
}

export interface ReferenceTableDefinition extends LabeledComponentDefinition,
    ValueComponentDefinition,
    ActionComponentDefinition {
    table: TableDefinition;
    finder: ItemFinderModalDefinition;
    outputParameterMappings?: ParameterMapping[];
}

